import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/vesselschedule/vsmigrationsynclog'
import pathMap from 'src/paths/PathMap_VesselSchedule'

class VsMigrationSyncLogRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.VS_MIGRATION_SYNC_LOG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.VS_MIGRATION_SYNC_LOG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.VS_MIGRATION_SYNC_LOG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.VS_MIGRATION_SYNC_LOG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default VsMigrationSyncLogRoute
